/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

// StrategyDashboard.jsx

import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import SideTagMenu from "./sideTagMenu";
import {fetchStockStrategies,fetchStockStrategyTags} from "../../api";


const StrategyDashboard = () => {
  const navigate = useNavigate();
  const [strategies, setStrategies] = useState([]);
  const [selectedStrategy, setSelectedStrategy] = useState(null);
  const [allTags, setAllTags] = useState([]);
  const [selectedTag, setSelectedTag] = useState(null);
  // const [filteredStrategies, setFilteredStrategies] = useState([]);

  const handleCardClick = (key) => navigate(`/ss/${key}`);
  // const handleTagClick = (tag) => setSelectedTag(tag);

  const iconMap = {
    "52_week_high_breakout": "📈",
    "relative_strength_rs_winners": "💪",
    "price_volume_surge": "🔥",
    "momentum_score": "📊",
    "moving_average_crossover": "🔁",

    "low_pe_high_roe": "📉",
    "magic_formula": "🪄",
    "dividend_yield_focus": "💵",
    "qarp": "🎯",
    "piotroski_f_score": "🧮",

    "high_eps_growth": "🚀",
    "revenue_compounders": "📈",
    "smallcap_stars": "🌟",
    "sector_leaders": "🏆",
    "pat_margin_expansion": "💼",
  };

  useEffect(() => {
  fetchStockStrategies().then(res => setStrategies(res));
}, []);
  console.log("STRATEGIES",strategies)


    // const handleTagSelect = (tag) => {
    // if (!tag) {
    //   setFilteredStrategies(strategies); // Clear filter
    // } else {
    //   const filtered = strategies.filter(s => s.tags && s.tags.includes(tag));
    //   setFilteredStrategies(filtered);
    // }

      const handleTagSelect = (tag) => {
    setSelectedTag(tag); // update selected tag
  };

    const filteredStrategies = selectedTag
    ? strategies.filter(s => s.tags && s.tags.includes(selectedTag))
    : strategies; // if no tag selected, show all

  return (
    <div style={styles.dashboardContainer}>
      <SideTagMenu onTagSelect={handleTagSelect} />
      <div style={styles.strategyGrid}>
        {filteredStrategies.map(strategy => (
          <div style={styles.card} key={strategy.key} onClick={() => handleCardClick(strategy.key)}>
            <h3>{iconMap[strategy.key] || '📚'} {strategy.name}</h3>
            <p>{strategy.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  dashboardContainer: {
    display: 'flex',
  },
  strategyGrid: {
    flex: 1,
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    // gridTemplateColumns: 'repeat(4, minmax(280px, 1fr))',
    gap: '20px',
    padding: '20px',
  },
  card: {
    border: '1px solid #ccc',
    padding: '16px',
    height: '20vh',
    borderRadius: '8px',
    background: '#f6f6f6',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    cursor: 'pointer',
  },
};

export default StrategyDashboard;